import img1 from "./e7608cea-6e3e-4f85-b5c8-879342324320.jpeg"
import img2 from "./e3d5fad3-21c2-4a00-b3ff-af0ae1f64a05.jpeg"
import img3 from "./0c242702-60ca-4e40-a275-e71920286695.jpeg"
import img4 from "./9949c630-672b-42a4-bb51-2343691fff6e.jpeg"
import img5 from "./8e3098d7-797f-4a3a-a17b-0ea89c4572bd.jpeg"
import img6 from "./4a141725-31d9-4d92-a468-b70c7e7ade4a.jpeg"
import img7 from "./cbd63bc8-c1d0-4de4-a027-3f5f56c02698.jpeg"


export const img=[img1,img2,img3,img4,img5,img6,img7]